import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 全局样式
import "@/assets/css/config.scss";
import "@/assets/css/common.scss";
import "swiper/css/swiper.min.css";


Vue.config.productionTip = false;
Vue.prototype.$apiYf = process.env.NODE_ENV === 'development' ? 'yfapi' : '//hisantech.com/';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
